import {
    INIT_GENERAL_SETTINGS,
    UPDATE_GENERAL_SETTINGS
} from './generalSettings.actionTypes';

export default function generalSettings(state = {}, action) {
	let newState = Object.assign({}, state);
	switch (action.type) {
		case INIT_GENERAL_SETTINGS:
            return {
                ...newState,
                generalSettings: action.generalSettings
            };
        case UPDATE_GENERAL_SETTINGS:
            return {
                ...newState,
                generalSettings: { ...state.generalSettings, [action.data.name]: action.data }
            };
		default:
			return newState;
	}
}
